function ThousandsSeparator(string:String|number, positive?:string) {
    let plus = ''
    if (positive) plus = positive
    const splitted=string?.toString().split('.')
    if(splitted && splitted[1] ) return  plus+ String(splitted[0]).replace(/\B(?=(\d{3})+(?!\d))/g, ",")+ (splitted[1]?("."+splitted[1]):'')
    else return  plus+ String(string).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}
export default ThousandsSeparator